import { useState } from 'react'
import type { FormEvent } from 'react'
import { login } from '../services/api'

export function Login({ onSuccess }: { onSuccess: (token: string) => void }) {
  const [password, setPassword] = useState('')
  const [message, setMessage] = useState('')
  const [busy, setBusy] = useState(false)
  async function submit(event: FormEvent): Promise<void> {
    event.preventDefault()
    setBusy(true)
    setMessage('')
    try { onSuccess(await login(password)) }
    catch (error) { setMessage(error instanceof Error ? error.message : 'No fue posible iniciar sesión.') }
    finally { setBusy(false) }
  }
  return <main className="login-shell"><section className="login-card"><div className="brand-mark">GH</div><p className="eyebrow">Instituto de Humanidades Luis Campino</p><h1>Gestor Pedagógico de Historia</h1><p>Administración curricular exclusiva de 6° Básico.</p><form onSubmit={submit}><label className="field"><span>Contraseña</span><input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required/></label>{message && <div className="alert error">{message}</div>}<button className="primary full" disabled={busy}>{busy ? 'Ingresando…' : 'Ingresar'}</button></form><small>La sesión se mantiene solo durante esta pestaña. Las eliminaciones pedirán nuevamente la contraseña.</small></section></main>
}
